import React from 'react'
import { Route, useRouteMatch } from 'react-router'

import Settings from '../../pages/Settings'

import SettingsEditProvider from '../../providers/SettingsEditProvider'
import ResponsiveSettingsProvider from '../../providers/ResponsiveSettingsProvider'

const SettingsRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Route
      path={path}
      render={() => (
        <SettingsEditProvider>
          <ResponsiveSettingsProvider>
            <Settings />
          </ResponsiveSettingsProvider>
        </SettingsEditProvider>
      )}
    />
  )
}

export default SettingsRoute
